/*
 * UnconditionalHideOption Messages
 *
 * This contains all the text for the UnconditionalHideOption container.
 */
import { defineMessages } from 'react-intl';

import { QUOTA_MODE } from 'data/quotaModes';

export const scope = 'app.containers.UnconditionalHideOption';

const messages = defineMessages({
  confirmHide: {
    title: {
      answer: {
        id: `${scope}.confirmHide.title.answer`,
        defaultMessage: 'Answer is used in logic rules',
      },
      row: {
        id: `${scope}.confirmHide.title.row`,
        defaultMessage: 'Statement is used in logic rules',
      },
      column: {
        id: `${scope}.confirmHide.title.column`,
        defaultMessage: 'Scale point is used in logic rules',
      },
    },
    body: {
      answer: {
        id: `${scope}.confirmHide.body.answer`,
        defaultMessage:
          'Removing this answer will affect the rules that use it. Choose how to handle affected rules:',
      },
      row: {
        id: `${scope}.confirmHide.body.row`,
        defaultMessage:
          'Removing this statement will affect the rules that use it. Choose how to handle affected rules:',
      },
      column: {
        id: `${scope}.confirmHide.body.column`,
        defaultMessage:
          'Removing this scale point will affect the rules that use it. Choose how to handle affected rules:',
      },
    },
    keepRules: {
      title: {
        id: `${scope}.confirmHide.keepRules.title`,
        defaultMessage: 'Keep rules',
      },
      description: {
        id: `${scope}.confirmHide.keepRules.description`,
        defaultMessage: 'These rules will be highlighted in red for review.',
      },
    },
    deleteRules: {
      title: {
        id: `${scope}.confirmHide.deleteRules.title`,
        defaultMessage: 'Delete rules',
      },
      description: {
        id: `${scope}.confirmHide.deleteRules.description`,
        defaultMessage:
          'Permanently deletes these rules, including any other conditions inside them.',
      },
    },
    confirmText: {
      id: `${scope}.confirmHide.confirmText`,
      defaultMessage: 'Remove answer & delete rules',
    },
    // Legacy primary button label for node hide (onSubmit-only modal).
    confirmTextLegacy: {
      id: `${scope}.confirmHide.confirmTextLegacy`,
      defaultMessage: 'Continue',
    },
    hideOnlyText: {
      id: `${scope}.confirmHide.hideOnlyText`,
      defaultMessage: 'Remove answer',
    },
    cancelText: {
      id: `${scope}.confirmHide.cancelText`,
      defaultMessage: 'Cancel',
    },
  },
  quotaRemoval: {
    max: {
      id: `${scope}.quotaRemoval.max`,
      defaultMessage:
        "Hiding it leaves too few visible options for per-answer targets, so this question's answer quotas will be removed.",
    },
    min: {
      id: `${scope}.quotaRemoval.min`,
      defaultMessage:
        "Hiding it leaves too few visible options for per-answer targets, so this question's minimum responses will be removed.",
    },
  },
  screenerTypeQuotaRemoval: {
    title: {
      id: `${scope}.screenerTypeQuotaRemoval.title`,
      defaultMessage: 'This question has screening quotas',
    },
    body: {
      id: `${scope}.screenerTypeQuotaRemoval.body`,
      defaultMessage:
        "This change leaves fewer than 2 allowed answers, so this question's screening quotas will be removed. They stay off if you allow more answers again.",
    },
  },
});

export default messages;

/** Quota-clearing confirm copy keyed by answer quota mode. */
export const QUOTA_REMOVAL_MESSAGE = {
  [QUOTA_MODE.MAX]: messages.quotaRemoval.max,
  [QUOTA_MODE.MIN]: messages.quotaRemoval.min,
};
